// проверка на таймзону gmt+3
export function isMoscowTimeZone(): boolean {
  const date = new Date()
  const offsetMinutes = Math.floor(Math.abs(date.getTimezoneOffset()) / 60)

  return offsetMinutes === 3
}
